import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { AcademySection } from './components/AcademySection';
import { LocationSection } from './components/LocationSection';
import { HoursSection } from './components/HoursSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark text-white selection:bg-gold/30 selection:text-white" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <AcademySection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <GallerySection data-id="element-7" />
        <LocationSection data-id="element-8" />
        <HoursSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}